module.exports = __webpack_public_path__ + "assets/computer.570941a7.svg";